import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LookupTableSearchFilter } from '../../../models/lookupTableSearchFilter';
import { Country } from '../../../models/country';
import { SearchableSelectComponent, Option } from '../searchable-select/searchable-select.component';

@Component({
  selector: 'app-lookup-table-search-box',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    SearchableSelectComponent
  ],
  templateUrl: './lookup-table-search-box.component.html',
  styleUrl: './lookup-table-search-box.component.scss'
})
export class LookupTableSearchBoxComponent implements OnChanges {
  @Input() isSearchVisible: boolean = false;
  @Input() countries: Country[] | null = null;
  @Input() showExactMatch: boolean = false;
  @Output() searchFilter = new EventEmitter<LookupTableSearchFilter>();

  searchForm = {
    name: undefined,
    exactMatch: false
  };

  countryControl = new FormControl<string | null>(null);
  countryOptions: Option[] = [];

  ngOnChanges(): void {
    if (this.countries) {
      this.countryOptions = this.countries.map(country => ({
        value: country.id,
        display: country.name
      }));
    }
  }

  onSearch(): void {
    const filter: any = { ...this.searchForm };
    if (this.countryControl.value) {
      filter.countryId = this.countryControl.value;
    }
    this.searchFilter.emit(filter);
  }

  clearSearch(): void {
    this.searchForm = {
      name: undefined,
      exactMatch: false
    };
    this.countryControl.setValue(null);
    this.searchFilter.emit({ ...this.searchForm });
  }
}
